module.exports = __webpack_public_path__ + "static/media/more-icon.9163f408.svg";